import "./AppointmentsCertificationAndConsentFormViewEditComponent.scss";
import React, {useCallback, useEffect} from "react";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {CommonService} from "../../../../shared/services";
import AppointmentsCertificationAndConsentFormViewComponent
    from "./appointments-certification-and-consent-form-view/AppointmentsCertificationAndConsentFormViewComponent";
import BackComponent from "../../../../shared/components/back/BackComponent";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import CardComponent from "../../../../shared/components/card/CardComponent";
import ClientRegistrationCertificationAndConsentComponent
    from "../../../client-registration/client-registration-certification-and-consent/ClientRegistrationCertificationAndConsentComponent";
import LoaderComponent from "../../../../shared/components/loader/LoaderComponent";
import StatusCardComponent from "../../../../shared/components/status-card/StatusCardComponent";

interface AppointmentsCertificationAndConsentFormViewEditComponentProps {

}

const AppointmentsCertificationAndConsentFormViewEditComponent = (props: AppointmentsCertificationAndConsentFormViewEditComponentProps) => {

    const [mode, setMode] = React.useState<'view' | 'edit'>('view');
    const params = useParams<{ formId: string ,appointmentId:string}>();
    const {formId,appointmentId} = params;
    const [certificationAndConsentDetails, setCertificationAndConsentDetails] = React.useState<any[]>([]);
    const [isCertificationAndConsentDetailsLoading, setIsCertificationAndConsentDetailsLoading] = React.useState<boolean>(false);
    const [isCertificationAndConsentDetailsLoadingFailed, setIsCertificationAndConsentDetailsLoadingFailed] = React.useState<boolean>(false);
    const [isCertificationAndConsentDetailsLoaded, setIsCertificationAndConsentDetailsLoaded] = React.useState<boolean>(false);
    const [search] = useSearchParams();
    const appointmentStatus = search.get('status');
    const navigate = useNavigate();

    const handleBackNavigation = useCallback(() => {
        if (mode === 'edit') {
            setMode('view')
        } else {
           navigate('/appointments/'+appointmentId)
        }
    }, [navigate,mode,appointmentId]);

    const handleEdit = useCallback(() => {
        setMode("edit");
    }, [])

    const getCertificationAndConsentDetails = useCallback((formId: string) => {
        setIsCertificationAndConsentDetailsLoading(true);
        setIsCertificationAndConsentDetailsLoadingFailed(false);
        setIsCertificationAndConsentDetailsLoaded(false);
        CommonService._appointment.getCertificationAndConsentDetails(formId)
            .then((response: any) => {
                    setCertificationAndConsentDetails(response.data);
                    setIsCertificationAndConsentDetailsLoading(false);
                    setIsCertificationAndConsentDetailsLoadingFailed(false);
                    setIsCertificationAndConsentDetailsLoaded(true);
                }
            ).catch((error: any) => {
            setIsCertificationAndConsentDetailsLoading(false);
            setIsCertificationAndConsentDetailsLoadingFailed(true);
            setIsCertificationAndConsentDetailsLoaded(false);
        })
    }, [])

    useEffect(() => {
        if (formId) {
            getCertificationAndConsentDetails(formId);
        }
    }, [getCertificationAndConsentDetails, formId]);

    const handleSubmit = useCallback((values: any) => {
        setCertificationAndConsentDetails(values);
        setMode('view');
    }, []);

    return (
        <div className={'appointments-certification-and-consent-form-view-edit-component appointment-form'}>
            <div className={'appointments-view-edit-form-header'}>
                <BackComponent onClick={() => {
                    handleBackNavigation()
                }}/>
                {
                    (appointmentStatus === 'scheduled' || appointmentStatus === 'upcoming') ? mode === 'view' &&
                        <ButtonComponent
                            prefixIcon={<CreateOutlinedIcon/>}
                            onClick={() => handleEdit()}
                        >
                            Edit
                        </ButtonComponent> : <></>
                }
            </div>
            {
                isCertificationAndConsentDetailsLoading && <LoaderComponent/>
            }
            {
                isCertificationAndConsentDetailsLoadingFailed &&
                <StatusCardComponent title={'Failed to load form details'}/>
            }
            {
                isCertificationAndConsentDetailsLoaded &&
                <CardComponent>
                    {
                        mode === 'view' ?
                            <AppointmentsCertificationAndConsentFormViewComponent
                                consentDetails={certificationAndConsentDetails}
                            /> :
                            <ClientRegistrationCertificationAndConsentComponent
                                initialValues={certificationAndConsentDetails}
                                formId={formId}
                                onSubmitComplete={handleSubmit}
                                appointmentId={appointmentId}
                            />
                    }
                </CardComponent>
            }
        </div>
    );

};

export default AppointmentsCertificationAndConsentFormViewEditComponent;
